import { styled, Button, Dialog, Box } from '@mui/material';

export const OutlinedButton = styled(Button)(({ theme }) => ({
  maxWidth: '200px',
  width: '200px',
  height: '48px',
  border: `1.5px solid ${theme.palette.secondary.main}`,
  color: theme.palette.secondary.main,
  backgroundColor: theme.palette.common.white,
  textTransform: 'lowercase',
  '&:disabled': {
    color: theme.palette.secondary.main,
  },
}));

export const FilledButton = styled(Button)(({ theme }) => ({
  width: '200px',
  height: '48px',
  color: theme.palette.common.white,
  textTransform: 'lowercase',
  '&:hover': {
    filter: 'brightness(85%)',
  },
}));

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    maxWidth: '1000px',
    borderRadius: 16,
    backgroundColor: theme.palette.common.white,
  },
}));

export const DialogContainer = styled(Box)(() => ({
  minWidth: 900,
  minHeight: 200,
  padding: '40px 40px',
  display: 'flex',
  flexDirection: 'column',
  gap: 20,
}));

export const MessageField = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  border: '1px solid #ADADAD',
  borderRadius: '21px',
  padding: ' 8px 12px',
}));

export const InputBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  '& .editor-content': {
    width: '100%',
  },
  '& .ProseMirror': {
    height: '380px',
    maxHeight: '380px',
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: '8px',
      marginLeft: 8,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.secondary.main,
      borderRadius: '10px',
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
      },
    },
    p: {
      margin: 8,
    },
    ':focus-visible': { outline: 'none' },
    'p.is-editor-empty': {
      marginTop: '0',
      '::before': {
        color: '#adb5bd',
        content: 'attr(data-placeholder)',
        pointerEvents: 'none',
      },
    },
  },
}));
